module.exports = __webpack_public_path__ + "img/mauritania.4a520f68.svg";